import { Link } from 'react-router-dom';
import './StudyList.css';

const StudyList = ({ title, studies }) => {
    return (
        <div className="study-list">
            <h2>{title}</h2>
            {studies.map((b, idx) => (
                <div className="study-preview" key={b.SeriesInstanceUID || idx}>
                    <Link to={`/studies/${b.StudyInstanceUID || ''}`} className="study-link">
                    <div><strong>PatientID:</strong> {b.PatientID || ''}</div>
                    <div><strong>PatientName:</strong> {b.PatientName || ''}</div>
                    <div><strong>StudyInstanceUID:</strong> {b.StudyInstanceUID || ''}</div>
                    <div><strong>StudyDate:</strong> {b.StudyDate || ''}</div>
                    <div><strong>StudyDescription:</strong> {b.StudyDescription || ''}</div>
                    <div><strong>SeriesDescription:</strong> {b.SeriesDescription || ''}</div>
                    <div><strong>SeriesInstanceUID:</strong> {b.SeriesInstanceUID || ''}</div>
                    <div><strong>SeriesNumber:</strong> {b.SeriesNumber || ''}</div>
                    <div><strong>SeriesDate:</strong> {b.SeriesDate || ''}</div>
                    <div><strong>Modality:</strong> {b.Modality || ''}</div>
                    <div><strong>InstanceCount:</strong> {b.InstanceCount || 0}</div>
                    </Link>
                    <div className="study-actions">
                        <Link to={`/viewer/series/${b.SeriesInstanceUID || ''}`}>
                            <button className="btn-primary retrieve-button">Retrieve (WADO) and View Series</button>
                        </Link>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default StudyList;
